import Utils from './Utils.js';
const singleton = Symbol();
const singletonEnforcer = Symbol();

class Common {

    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) {
            throw "Cannot--construct singleton"
        }

        this._option = {
            container: '#fullscreen-ui',
            transitionDuration: 600,
            motionStyle: 'scroll', // 'scroll' or 'cover'
            useSubNavi: true,
            useMouseWheel: true,
            callBack: null
        };
    }

    static get instance() {
        if(!this[singleton]) {
            this[singleton] = new Common(singletonEnforcer);
        }
        return this[singleton];
    }

    init(_option){
        $.extend(true, this._option, _option);
        if(Utils.isMobile) this._option.transitionDuration = 320;

        this._mainContainer = $(this._option.container);
        this._sectionList = [];
        this._depth = { d1: 1, d2: 1 };


        if(this._option.motionStyle=='cover'){
            this._mainContainer.addClass('cover-mode');
        }
    }

    get option(){
        return this._option;
    }

    get depth(){
        return this._depth;
    }

    set depth(_depth){
        this._depth = _depth;
    }

    get mainContainer(){
        return this._mainContainer;
    }

    get sectionList(){
        return this._sectionList;
    }

    set sectionList(_list){
        this._sectionList = _list;
    }



}

export default Common;



// WEBPACK FOOTER //
// ./Common.js